import { ComponentType } from 'react';

import { COLORS } from '@/styles/tokens/colors';

import { Button, ButtonProps } from '../form/baseInputs/Button';
import { IconProps } from '../icons/ChevronDownIcon';
import { ActionCard } from '../layout/ActionCard/ActionCard';

export interface EmptyListActionCardProps {
  icon?: ComponentType<IconProps>;
  heading: string;
  description: string;

  // you can either pass buttonOnClick/buttonText or action
  buttonOnClick?: () => void;
  buttonText?: React.ReactNode;
  buttonStartIcon?: ButtonProps['startIcon'];
  action?: React.ReactNode;
  hideButton?: boolean;
  disabled?: boolean;
  size?: 'sm' | 'lg';
}

export function EmptyListActionCard({
  icon: Icon,
  buttonText,
  buttonOnClick,
  buttonStartIcon,
  action,
  hideButton,
  disabled,
  size,
  ...cardProps
}: EmptyListActionCardProps) {
  return (
    <ActionCard
      variant="noCard"
      icon={Icon && <Icon size={32} sx={{ color: COLORS.TEXT.PRIMARY }} />}
      sx={{ maxWidth: 400, mx: 'auto', alignSelf: 'center' }}
      {...cardProps}
      actions={
        hideButton
          ? undefined
          : action || (
              <Button
                startIcon={buttonStartIcon}
                onClick={() => buttonOnClick?.()}
                variant="primary"
                size="sm"
                disabled={disabled}
              >
                {buttonText || 'Add item'}
              </Button>
            )
      }
    />
  );
}
